<template>
  <div>
    <el-tabs v-model="type" @tab-click="tabChange">
      <el-tab-pane label="汇总" name="total"></el-tab-pane>
      <el-tab-pane label="详情" name="detail"></el-tab-pane>
      <el-tab-pane label="排名" name="rank"></el-tab-pane>
    </el-tabs>
    <el-card v-show="type === 'total'">
      <el-input v-model="search" size="mini" class="search" placeholder="输入币种搜索"/>
      <el-table v-if="tableAble" :data="showData">
        <el-table-column label="币种" prop="coinType"></el-table-column>
        <el-table-column label="转入" prop="lockIn"></el-table-column>
        <el-table-column label="转出" prop="lockOut"></el-table-column>
        <el-table-column label="余额" prop="balance"></el-table-column>
        <el-table-column label="利息" prop="interest"></el-table-column>
      </el-table>
    </el-card>
    <el-card v-show="type === 'detail'">
      <el-input v-model="coinType" size="mini" class="search" placeholder="输入币种搜索"/>
      <el-date-picker
        v-model="dateVal"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="mini"
        class="date-search"/>
      <el-select v-model="utype" size="mini" placeholder="类型" class="search">
        <el-option :value="''" label="全部">全部</el-option>
        <el-option value="0" label="转入">转入</el-option>
        <el-option value="1" label="转出">转出</el-option>
      </el-select>
      <el-input v-model="userId" size="mini" @change="queryDetailData" placeholder="用户ID" class="search"/>
      <el-button type="primary" icon="el-icon-search" @click="queryDetailData()" circle size="mini"/>
      <el-table v-if="tableAble" :data="currentLock">
        <el-table-column label="币种" prop="coinType"></el-table-column>
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            {{ scope.row.type == 0 ? "转入" : "转出" }}
          </template>
        </el-table-column>
        <el-table-column label="数额" prop="amount"></el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <pagination :size="pager.size" :page="pager.page" :total="currentLockTotal" @pageChanged="handlPageChanged"/>
      </div>
    </el-card>
    <el-card v-show="type === 'rank'">
      <el-input v-model="rankUserId" size="mini" class="search" placeholder="输入用户ID"/>
      <el-input v-model="rankCoinType" size="mini" class="search" placeholder="输入币种"/>
      <el-button type="primary" icon="el-icon-search" @click="queryRank()" circle size="mini"/>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;总人数：{{currentRank.length}}&nbsp;&nbsp;&nbsp;&nbsp;总额：{{totalAmount(currentRank)}}</span>
      <el-table v-if="tableAble" :data="currentRank">
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="币种" prop="coinType"></el-table-column>
        <el-table-column label="数额" prop="amount"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import "../store.js";
import { mapState, mapActions } from "vuex";
import Pagination from "components/pagination";
import { formatTable } from "../../../common/tools.js";
export default {
  name: "dataCenterCurrent",
  data() {
    return {
      type: "total",
      search: "",
      coinType: "",
      dateVal: "",
      utype: "",
      userId: "",
      rankCoinType: "BTC",
      rankUserId: "",
      pager: {
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    ...mapActions("dataCenter", ["getCurrentBalance", "getCurrentLock", "getCurrentRank"]),
    queryData() {
      this.getCurrentBalance();
    },
    queryDetailData() {
      let q = {
        coinType: this.coinType,
        page: this.pager.page,
        size: this.pager.size,
      };
      if (this.dateVal) {
        q.startTime = this.dateVal[0].getTime();
        q.endTime = this.dateVal[1].getTime();
      }
      if (this.utype != "") q.type = this.utype;
      if (this.userId) q.userId = this.userId;
      this.getCurrentLock(q);
    },
    tabChange() {
      if (this.type === "total") {
        this.queryData();
      } else if (this.type === 'detail') {
        this.queryDetailData();
      } else if (this.type === 'rank') {
        this.queryRank();
      }
    },
    handlPageChanged(pagination) {
      this.pager.page = pagination.page;
      this.pager.size = pagination.size;
      this.queryDetailData();
    },
    queryRank() {
      this.getCurrentRank({
        coinType: this.rankCoinType,
        userId: this.rankUserId
      })
    },
    totalAmount(list) {
      let total = 0;
      for(let i in list) {
        total = total + list[i].amount;
      }
      return total;
    }
  },
  computed: {
    ...mapState("dataCenter", [
      "currentBalance",
      "currentCoins",
      "currentLock",
      "currentLockTotal",
      "currentRank",
      "tableAble"
    ]),
    showData() {
      let re = [];
      if (this.search) {
        re = this.currentBalance.filter((v, i, a) => {
          return (
            v.coinType.toLowerCase().indexOf(this.search.toLowerCase()) != -1
          );
        });
      } else {
        re = this.currentBalance.slice(0);
      }
      return re;
    },
  },
  watch: {
    showData() {
      formatTable();
    },
    currentLock() {
      formatTable();
    },
    currentRank() {
      formatTable();
    }
  },
  mounted() {
    this.queryData();
  },
  components: {
    Pagination,
  },
};
</script>
<style scoped>
.search {
  width: 200px;
  margin: 0px 20px 20px 0px;
}
.date-search {
  margin-right: 20px;
}
</style>
